import { render, staticRenderFns } from "./NewsBannersEdit.vue?vue&type=template&id=44972a34&scoped=true"
import script from "./NewsBannersEdit.vue?vue&type=script&lang=js"
export * from "./NewsBannersEdit.vue?vue&type=script&lang=js"
import style0 from "./NewsBannersEdit.vue?vue&type=style&index=0&id=44972a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44972a34",
  null
  
)

export default component.exports